import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
// import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import * as moment from 'moment';
import * as service from '../../../services/service';

function ItemDemand() {
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [details, setDetails] = useState([]);
    // const [vendorId, setVendorId] = useState('');
    // const [VendorData, setVendorData] = useState([]);
    const [error, setError] = useState(null);
    const [dataError, setDataError] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    // const getVendors = () => {
    //     fetch(
    //         service.VENDOR_URL,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             const data2 = result.map((item) => ({ value: item.vendorId, label: item.vendorName }));
    //             setVendorData(data2);
    //         });
    // };

    const validate = () => {
        let isValid = true;
        if (!search) {
            isValid = false;
            setError("Please enter demand number");
        }
        else {
            setError('');
        }
        return isValid;
    }
    const getDetails = () => {
        setLoading(true);
        if (validate()) {
            fetch(
                service.ITEM_DEMAND_BY_SEARCH_URL,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DemandNo: search,
                        // VendorId: vendorId.value,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === "Failed") {
                        setDataError(result.message.message);
                        setData([]);
                        setDetails([]);
                    }
                    else {
                        setData(result);
                        setDetails(result.itemDemandDetails);
                        setDataError('');
                    }
                })
                .catch(err => {
                    if (err) {
                        setDataError(err);
                    };
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
       // getVendors();
        setLoading(false);
    }, []);

    // const vendorChangeHandler = (ev) => {
    //     setVendorId(ev);
    // }
    const addNew = () => {
        navigate('/additemdemand/0');
    };

    const handleDelete = (demandId, detailId) => {
        setLoading(true);
        fetch(
            service.DELETE_ITEM_DETAILS_DEMAND,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    DetailId: detailId,
                    DemandId: demandId
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === "Failed") {
                    setDataError(result.message.message);
                }
                else {
                    // eslint-disable-next-line                              
                    alert('Data Deleted Sucessfully');
                }
            })
            .catch(err => {
                if (err) {
                    setDataError(err);
                };
            });
        window.location.reload();
        setLoading(false);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ float: 'right' }}>
                <MDButton color="info" onClick={addNew}>
                    ADD NEW
                </MDButton>
            </div>
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Item Demand Details
                                </MDTypography>
                            </MDBox>
                            <br />
                            <MDBox mx={2}
                                mt={-3}
                                py={3}
                                px={2}>
                                <Stack direction="row" spacing={5}>
                                    <MDInput label="Demand No." value={search}
                                        name="search"
                                        onChange={ev => setSearch(ev.target.value)}
                                        id="search"
                                        required
                                    />
                                    {/* <div style={{ width: '20%', fontSize: '14px' }}>
                                        <Dropdown menuClassName='myMenuClassName' id="vendor"
                                            name="vendor"
                                            options={VendorData}
                                            value={vendorId}
                                            onChange={vendorChangeHandler}
                                            label="Vendor"
                                            placeholder="Select Vendor"
                                        />
                                    </div> */}
                                    <MDButton color="info" onClick={getDetails} endIcon={<SearchIcon />}>
                                        Search
                                    </MDButton>
                                </Stack>
                               <div style={{ fontSize: '12px', color: 'green' }}>Search by Demand No</div>
                                <div style={{ fontSize: '12px', color: 'red' }}>{error}</div>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <div style={{ fontSize: '12px', color: 'red' }}>{dataError}</div>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center' }}>
                                        <Table aria-label="simple table">
                                            <TableRow style={{ backgroundColor: 'lightgrey' }}>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item Category</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Item</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Unit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Vendor</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Demand No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Demand Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', fontSize: '14px' }}>Delete</TableCell>
                                            </TableRow>

                                            <TableBody>
                                                {details.map((row) => (
                                                    <TableRow
                                                        key={row.detailId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell style={{ fontSize: '14px' }}>{row.itemCategory}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.item}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.quantity}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{row.unit}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{data.vendorName}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{data.demandNo}</TableCell>
                                                        <TableCell style={{ fontSize: '14px' }}>{moment(data.demandDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell><MDButton onClick={() => handleDelete(data.demandId, row.detailId)}>Delete</MDButton></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default ItemDemand;